export default function _updateMessages (locale, messages) {
  return {
    type: 'UPDATE_LOCALE_MESSAGES',
    payload: {locale, messages},
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_updateMessages.js